export default function localReducer(state,action){
  return { ...state, ...action }
}
